/**
 * backToTop.js — 「トップに戻る」ボタン
 *
 * .js-back-top 要素が存在する場合に有効。
 * スクロール位置に応じて表示/非表示を切り替える。
 */
export function initBackToTopButton() {
  const backToTopButton = document.querySelector(".js-back-top");

  if (!backToTopButton) return;

  function toggleBackToTopButton() {
    if (window.scrollY > 300) {
      backToTopButton.classList.remove("_hidden");
      backToTopButton.setAttribute("tabindex", "0");
    } else {
      backToTopButton.classList.add("_hidden");
      backToTopButton.setAttribute("tabindex", "-1");
    }
  }

  toggleBackToTopButton();
  window.addEventListener("scroll", toggleBackToTopButton);

  backToTopButton.addEventListener("click", function (e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
}
